<loading-line></loading-line>

<public-project-message *ngIf="showPublicProjectWarning$ | async"></public-project-message>

<router-outlet></router-outlet>
